import behavior from './behavior.mjs';
import nft from './nft.mjs'
import wallet from './wallet.mjs'


(async function main() {
  behavior();
  await wallet.init();

  const nftArray = await nft.getNfts();
  console.log(nftArray);
})();
